import React from "react";
import { Pin, Tee, Onesie, Sock } from "./garments";

// The clothesline sags from (8,20) through (120,52) to (232,20); a point at
// x sits at y = 20 + 64t(1 - t) with t = (x - 8) / 224.
const lineY = (x) => {
  const t = (x - 8) / 224;
  return 20 + 64 * t * (1 - t);
};

const CLOTHES = [
  { x: 62, Item: Tee, color: "#CDEEFB", delay: "0s", duration: "2.6s" },
  { x: 120, Item: Onesie, color: "#FFD45C", delay: "-0.8s", duration: "3.1s" },
  { x: 176, Item: Sock, color: "#C9C2FF", delay: "-1.6s", duration: "2.3s" },
];

// Friendly empty message: a little clothesline whose clothes sway and a
// ring that bounces (styles in kido-ui.css). `hint` adds a second line.
const EmptyState = ({ children, hint }) => (
  <div className="kd-empty-state kd-empty-state--inline" role="status">
    <svg className="kd-empty-art" viewBox="0 0 240 116" aria-hidden="true" focusable="false">
      <path d="M8 20 Q120 52 232 20" className="kd-empty-art-line" />
      {CLOTHES.map(({ x, Item, color, delay, duration }) => (
        <g key={x} transform={`translate(${x} ${lineY(x).toFixed(1)}) scale(0.62)`}>
          <g
            className="kd-empty-art-swing"
            style={{ animationDelay: delay, animationDuration: duration }}
          >
            <g transform="translate(0 4)">
              <Item color={color} />
            </g>
            <Pin />
          </g>
        </g>
      ))}
      <ellipse cx="224" cy="108" rx="9" ry="2.5" className="kd-empty-art-shadow" />
      <circle cx="224" cy="96" r="7" className="kd-empty-art-ball" />
    </svg>
    <p>{children}</p>
    {hint && <small>{hint}</small>}
  </div>
);

export default EmptyState;
